import { cn } from '@/lib/utils'
import { SAR_SYMBOL } from '@/utils/formatters'

interface CurrencySymbolProps {
  amount: number | null | undefined
  className?: string
  showDecimals?: boolean
}

export function CurrencySymbol({
  amount,
  className,
  showDecimals = true,
}: CurrencySymbolProps) {
  if (amount === null || amount === undefined) {
    return <span className={className}>{SAR_SYMBOL} 0.00</span>
  }

  const formattedAmount = showDecimals
    ? amount.toFixed(2)
    : amount.toString()

  const numberWithCommas = formattedAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return (
    <span className={cn('inline-flex items-center', className)}>
      <img
        src="/lovable-uploads/eb5e61e4-9905-4272-bcb5-7085d7d397a7.png"
        alt={SAR_SYMBOL}
        className="w-4 h-4 mr-1"
        onError={(e) => {
          const target = e.target as HTMLImageElement
          target.style.display = 'none'
          const parent = target.parentElement
          if (parent && !parent.querySelector('.sar-fallback')) {
            const fallback = document.createElement('span')
            fallback.className = 'sar-fallback'
            fallback.textContent = `${SAR_SYMBOL} `
            parent.insertBefore(fallback, target)
          }
        }}
      />
      <span>{numberWithCommas}</span>
    </span>
  )
}
